import Vue from 'vue'

export type SetasTabela = { left: boolean, right: boolean }

type Observacao = { el: HTMLElement, observer: ResizeObserver, aoRolar: () => void }

// Setas de rolagem horizontal das tabelas largas. O v-data-table recria o elemento quando o
// conteudo volta de um v-if: a observacao e refeita quando o elemento muda, senao as setas
// ficariam presas ao elemento antigo.
export default function useScrollArrowsTabela(obterOverflow: (refName: string) => HTMLElement | null) {
  const estado = Vue.observable<{ setas: Record<string, SetasTabela> }>({ setas: {} })
  const observacoes: Record<string, Observacao> = {}

  function atualizar(refName: string) {
    const el = obterOverflow(refName)
    if (!el) return

    const temOverflow = el.scrollWidth > el.clientWidth
    Vue.set(estado.setas, refName, {
      left: temOverflow && el.scrollLeft > 0,
      right: temOverflow && el.scrollLeft < el.scrollWidth - el.clientWidth - 1,
    })
  }

  function desanexar(refName: string) {
    const observacao = observacoes[refName]
    if (!observacao) return

    observacao.observer.disconnect()
    observacao.el.removeEventListener('scroll', observacao.aoRolar)
    delete observacoes[refName]
  }

  function anexar(refName: string) {
    const el = obterOverflow(refName)
    if (!el) return

    const atual = observacoes[refName]
    if (atual && atual.el !== el) desanexar(refName)

    if (!observacoes[refName]) {
      const aoRolar = () => atualizar(refName)
      el.addEventListener('scroll', aoRolar)
      const observer = new ResizeObserver(aoRolar)
      observer.observe(el)
      observacoes[refName] = { el, observer, aoRolar }
    }

    atualizar(refName)
  }

  function rolar(refName: string, delta: number) {
    const el = obterOverflow(refName)
    if (!el) return

    el.scrollBy({ left: delta, behavior: 'smooth' })
    Vue.nextTick(() => atualizar(refName))
  }

  function destruir() {
    Object.keys(observacoes).forEach(desanexar)
  }

  return {
    get setas() {
      return estado.setas
    },
    anexar,
    atualizar,
    rolar,
    destruir,
  }
}
